import React from "react";
import twitter from "../../../assets/v3/images/twitter-logo.svg";
import linkedin from "../../../assets/v3/images/linkedin-logo.svg";
import telegram from "../../../assets/v3/images/telegram-logo.svg";
import youtube from "../../../assets/v3/images/youtube-logo.svg";
import discord from "../../../assets/v3/images/discord-logo.svg";

// icons
import { FaTwitter,FaFacebookF,FaMedium,FaInstagram,FaLinkedin,FaPinterest,FaWhatsapp    } from "react-icons/fa";

import { Link } from "react-router-dom";

import { useContextData } from "../../../core/context/index";

import Config from "../../../core/config/index";

const Footer = () => {
  const { siteSettings } = useContextData();

  return (
    <section className="footer">
      <div className="footer-container">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="footer-content-1">
              <h2 className="f-text-1">CoinDH</h2>
              <p className="foot-link lh-lg">A FIU(Govt. of India) registered entity with REID: VA00063924</p>
              <h2 className="f-text-2 mt-4">BE PART OF OUR COMMUNITY</h2>
              <div className="footer-social-div">
                {siteSettings && siteSettings.twitterLink ? (
                  <a href={siteSettings.twitterLink} target="_blank">
                    <div className="footer-social-link">
                      <FaTwitter className="text-primary" size={20}/>
                    </div>
                  </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.telegramLink ? (
                <a href={siteSettings.telegramLink} target="_blank">
                  <div className="footer-social-link">
                    <img
                      src={telegram}
                      width={25}
                      height={25}
                      alt="telegram"
                      className="f-social-link-img"
                    />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.youtubeLink ? (
                <a href={siteSettings.youtubeLink} target="_blank">
                  <div className="footer-social-link">
                    <img
                      src={youtube}
                      width={25}
                      height={25}
                      alt="youtube"
                      className="f-social-link-img"
                    />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.facebookLink ? (
                <a href={siteSettings.facebookLink} target="_blank">
                  <div className="footer-social-link">
                    <FaFacebookF className="text-primary" size={20}/>
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.mediumLink ? (
                <a href={siteSettings.mediumLink} target="_blank">
                  <div className="footer-social-link">
                    <FaMedium className="text-dark" size={20} />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.instagramLink ? (
                <a href={siteSettings.instagramLink} target="_blank">
                  <div className="footer-social-link">
                    <FaInstagram  className="insta" size={20} />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.linkedinLink ? (
                <a href={siteSettings.linkedinLink} target="_blank">
                  <div className="footer-social-link">
                    <FaLinkedin  className="linkedin" size={20} />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.pinterestLink ? (
                <a href={siteSettings.pinterestLink} target="_blank">
                  <div className="footer-social-link">
                    <FaPinterest  className="text-danger" size={20} />
                  </div>
                </a>
                ) : (
                  <></>
                )}
                {siteSettings && siteSettings.whatsappLink ? (
                <a href={siteSettings.whatsappLink} target="_blank">
                  <div className="footer-social-link">
                    <FaWhatsapp   className="text-success" size={20} />
                  </div>
                </a>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-12 ">
            <div className="footer-content-2">
              <h2 className="f-text-2">SERVICES</h2>
              <ul className="footer-ul">
                <li className="footer-li">
                  <Link to={'/spot/BDX_INR'} className="foot-link">
                    Exchange
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to={'/trade/all-payments'} className="foot-link">
                    P2P
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/staking" className="foot-link">
                    Staking
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/my/referral" className="foot-link">
                    Refer & Earn
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-12 ">
            <div className="footer-content-2">
              <h2 className="f-text-2">INFORMATION</h2>
              <ul className="footer-ul">
                <li className="footer-li">
                  <Link to="/markets" className="foot-link">
                    Market
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/fee-structure" className="foot-link">
                    Fees
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/coin-status" className="foot-link">
                    Coin Status
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-12 ">
            <div className="footer-content-2">
              <h2 className="f-text-2">Contact</h2>
              <ul className="footer-ul">
                {Config.coinListing ?
                <li className="footer-li">
                  <a className="foot-link" href={Config.coinListing} target={"_blank"}>Coin Listing</a>
                </li>:<></>}
                {siteSettings && siteSettings.supportEmail ? <li className="footer-li"> <a className="foot-link" href={"mailto:" + siteSettings.supportEmail}>{siteSettings.supportEmail}</a> </li> :<></>}
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-12 ">
            <div className="footer-content-2">
              <h2 className="f-text-2">ABOUT US</h2>
              <ul className="footer-ul">
                <li className="footer-li">
                  <Link to="/about" className="foot-link">
                    About us
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/faq" className="foot-link">
                    FAQ's
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/terms" className="foot-link">
                    Terms & Condition
                  </Link>
                </li>
                <li className="footer-li">
                  <Link to="/privacy-policy" className="foot-link">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-container-2">
        <div className="d-flex flex-column justify-content-center align-items-center gap-3 my-4">
          <h4 className="text-danger text-uppercase">Risk Warning</h4>
          {/* <small>Crypto trading is subject to high market risk. We request you to trade cautiously. <Link to="/about" className="fw-bold text-own">CoinDH</Link>  will provide its best efforts to list quality cryptos, and we will not be responsible for your trading losses.</small> */}
          <small>Cryptocurrency trading carries high market risks. Please trade carefully. While CoinDH aims to list quality cryptocurrencies, we are not responsible for any trading losses.</small>
        </div>
        <p className="f-text-3 text-center">{siteSettings && siteSettings.copyRights ? siteSettings.copyRights : ""}</p>
      </div>
    </section>
  );
};

export default Footer;
